(function() {
  "use strict";
  angular.module("marketPlace.preview", ["marketPlace.lodash"]);
})();
